<section class="partner-roadshow" id="partnerRoadshow-id">
  <div class="box">
    <h3 class="box-heading">
      <span>{{ 'PARTNER_ROADSHOW.HEADING' | translate }}</span>
    </h3>

    <div class="box-wrapper">
      <div class="box-wrapper__left">
        <div class="box-wrapper__left--text">
          <div class="text-title desktop">
            <span>{{ 'PARTNER_ROADSHOW.CONTENT.TITLE' | translate }}</span>
          </div>

          <div class="text-detail">
            <span>{{ 'PARTNER_ROADSHOW.CONTENT.DETAIL' | translate }}</span>
          </div>

          <div class="text-btn">
            <a
              class="text-btn__layout"
              [href]="[
                translate.currentLang === 'th' ? '/partner-roadshow' : translate.currentLang + '/partner-roadshow'
              ]"
              rel="noopener noreferrer"
              target="_blank"
              ><span>{{ 'PARTNER_ROADSHOW.CONTENT.BTN' | translate }}</span></a
            >
          </div>
        </div>
      </div>
      <div class="box-wrapper__right">
        <video
          class="box-wrapper__right--vdo"
          muted
          loop
          playsinline
          autoplay
          [poster]="
            'https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner-roadshow/roadshow.png'
          "
          loading="lazy"
        >
          <source
            src="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner-roadshow/roadshow-motion.mp4"
            type="video/mp4"
          />
        </video>
        <img
          [src]="
            'https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner-roadshow/roadshow.png'
          "
          [alt]="'PARTNER_ROADSHOW.CONTENT.TITLE' | translate"
          loading="lazy"
          class="box-wrapper__right--img"
        />
      </div>
    </div>
  </div>
</section>
